var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnfollowninja(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 978.43 978.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:#15162e;}.c{fill:url(#b);}.d{fill:url(#c);}.e{fill:url(#d);}.f{fill:url(#e);}.g{fill:none;stroke-miterlimit:10;stroke:url(#f);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 393.35,
    y1: 606.91,
    x2: 1019.35,
    y2: 808.91,
    gradientTransform: "translate(708.66 -293.54) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#dc4692"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#59c1d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 474.38,
    y1: 316.21,
    x2: 1130.26,
    y2: 527.85,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 280.09,
    y1: 887.62,
    x2: 939.09,
    y2: 1100.27,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 394.22,
    y1: 599.67,
    x2: 1023.75,
    y2: 802.81,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 389.58,
    y1: 612.58,
    x2: 1018.37,
    y2: 815.48,
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 669.89,
    y1: 669.89,
    x2: 747.43,
    y2: 747.43,
    gradientTransform: "translate(708.66 -293.54) rotate(45)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#76ccf4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d376ad"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M974.76,1085.24c6.2-38.75,4.72-84.15-4.29-131.3C952.59,860.27,907.78,769.27,850,708.71l2.27-2.31c18.25-18.61,34.35-36.24,49.92-53.3s30.21-33.08,45-47.85c35.83-35.79,79-71.46,152-90q1.68-.43,3.39-.84c9.17-2.24,18.86-4.24,28.79-5.93l3.81-.64c2.55-.41,5.17-.81,7.78-1.19,11.88-1.74,24.54-3.13,37.61-4.16l17.3-1.36-12.27-12.27c-23.9-23.9-57.66-39.49-100.36-46.32-38.75-6.2-84.15-4.72-131.3,4.29-93.67,17.88-184.67,62.69-245.23,120.47l-2.31-2.27c-18.61-18.25-36.24-34.35-53.29-49.92s-32.87-30-47.56-44.69l-.3-.31c-35.79-35.83-71.46-79.05-90-152q-.43-1.68-.84-3.39c-2.24-9.17-4.24-18.86-5.93-28.79-.22-1.26-.43-2.53-.64-3.81-.41-2.54-.81-5.16-1.19-7.78-1.74-11.89-3.13-24.54-4.16-37.61l-1.36-17.3-12.27,12.27c-23.9,23.9-39.49,57.66-46.32,100.36-6.2,38.75-4.72,84.15,4.29,131.3,17.88,93.67,62.69,184.67,120.47,245.23l-2.27,2.31c-2.48,2.52-5,5.15-7.6,7.82q-2.49,2.58-4.94,5.16L547.65,729c-3,3.23-6.14,6.53-9.45,10.09-8,8.59-15.65,17-23.07,25.11-15.53,17-30.21,33.09-45,47.86-35.26,35.21-77.67,70.38-148.65,89.11-1.1.3-2.22.58-3.34.87-2.24.57-4.54,1.13-6.84,1.67s-4.66,1.07-7,1.57c-4.74,1-9.64,2-14.57,2.87-7.51,1.35-15.36,2.56-23.34,3.59-2.69.35-5.44.69-8.19,1-6.93.8-14.14,1.49-21.44,2.06l-17.31,1.36,12.28,12.27c23.9,23.9,57.66,39.49,100.36,46.32,38.75,6.2,84.15,4.72,131.3-4.29C557.05,952.59,648.05,907.78,708.61,850l2.31,2.27c2.54,2.49,5.17,5.05,7.82,7.6q2.58,2.49,5.15,4.94l5.12,4.86c3.23,3,6.53,6.14,10.09,9.45,8.59,8,17,15.65,25.11,23.07,16.9,15.43,32.87,30,47.56,44.7l.3.3c30,30,60.45,65.36,80.31,120.32.72,2,1.43,4,2.11,6,2.08,6.13,4,12.52,5.8,19,.9,3.29,1.78,6.67,2.6,10,1.12,4.56,2.18,9.28,3.16,14,.49,2.4,1,4.85,1.43,7.29s.91,5,1.34,7.48c.22,1.26.43,2.53.64,3.81.41,2.56.81,5.17,1.19,7.78,1.74,11.88,3.13,24.54,4.16,37.61l1.36,17.3,12.27-12.27C952.34,1161.7,967.93,1127.94,974.76,1085.24Zm-56.19,56.56c-.39-2.66-.79-5.3-1.22-7.9-.21-1.3-.42-2.59-.64-3.88q-.66-3.86-1.37-7.61t-1.46-7.42q-1.51-7.34-3.21-14.31-1.27-5.22-2.66-10.27-2.76-10.08-5.94-19.44-1.07-3.13-2.16-6.18c-18.76-51.88-47.12-88.15-82.18-123.25l-.31-.31c-21.92-21.92-46.45-43.41-72.87-68q-5-4.63-10-9.41c-1.69-1.6-3.38-3.2-5.08-4.83s-3.42-3.26-5.13-4.91q-3.87-3.72-7.77-7.55L713.91,844c-1.75-1.72-3.49-3.46-5.25-5.21-124,124-377,178.26-471.29,84,7.48-.59,14.71-1.29,21.73-2.09q4.2-.48,8.31-1,12.31-1.61,23.72-3.65,7.61-1.37,14.85-2.93,3.61-.78,7.15-1.6c2.35-.56,4.68-1.12,7-1.71l3.43-.88c68-18,111-49.94,152.25-91.19,22-22,43.6-46.63,68.28-73.18q4.63-5,9.41-10c1.6-1.69,3.2-3.38,4.83-5.08s3.26-3.42,4.91-5.13q3.72-3.87,7.55-7.77l2.57-2.61c1.72-1.75,3.46-3.49,5.21-5.25-124-124-178.26-377-84-471.29,1.06,13.45,2.47,26.14,4.22,38.15.39,2.66.79,5.3,1.22,7.9.21,1.3.42,2.59.64,3.88,1.76,10.28,3.77,20,6,29.34.29,1.16.57,2.31.87,3.46,17.78,70,50.13,113.69,92.07,155.68.1.11.2.21.31.31,29.49,29.49,63.7,58.19,100.9,94.67l2.61,2.57c1.75,1.72,3.49,3.46,5.25,5.21,124-124,377-178.26,471.29-84-13.45,1.06-26.14,2.47-38.15,4.22-2.66.39-5.3.79-7.9,1.22l-3.88.64c-10.28,1.76-20,3.77-29.34,6-1.16.29-2.31.57-3.46.87-70,17.78-113.69,50.13-155.68,92.07-29.6,29.56-58.37,63.88-95,101.21L844,703.41c-1.72,1.75-3.46,3.49-5.21,5.25,124,124,178.26,377,84,471.29C921.73,1166.5,920.32,1153.81,918.57,1141.8Z",
    transform: "translate(-219.44 -219.45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1180,494.53c-94.26-94.25-347.32-39.95-471.29,84C596.3,466.19,509.56,428.62,494.53,237.37c-94.25,94.26-39.95,347.32,84,471.29C466.19,821,428.62,907.76,237.37,922.79c94.26,94.25,347.32,40,471.29-84C821,951.13,907.76,988.7,922.79,1180c94.25-94.26,40-347.32-84-471.29C951.13,596.3,988.7,509.56,1180,494.53ZM670.24,747.08a54.33,54.33,0,1,1,76.84,0A54.33,54.33,0,0,1,670.24,747.08Z",
    transform: "translate(-219.44 -219.45)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M790.79,684.09,846.48,712C958.83,599.65,990.8,509.93,1182,494.9,913.62,445,790.79,684.09,790.79,684.09Z",
    transform: "translate(-219.44 -219.45)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M625.67,733.07,569.82,705c-112.36,112.36-143.4,202.38-334.64,217.4C503.61,972.25,625.67,733.07,625.67,733.07Z",
    transform: "translate(-219.44 -219.45)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M683.85,627.87l28.2-56.06c-112.36-112.36-201.95-146.22-217-337.47C445.22,502.77,683.85,627.87,683.85,627.87Z",
    transform: "translate(-219.44 -219.45)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M733.47,789.45l-27.61,55.18C818.21,957,907.33,991.09,922.36,1182.33,972.22,913.9,733.47,789.45,733.47,789.45Z",
    transform: "translate(-219.44 -219.45)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M747.08,747.08a54.33,54.33,0,1,1,0-76.84A54.33,54.33,0,0,1,747.08,747.08Z",
    transform: "translate(-219.44 -219.45)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfollowninja);
export default __webpack_public_path__ + "static/media/unfollowninja.1ebddd75bd0de52f59d1d190ba9381e1.svg";
export { ForwardRef as ReactComponent };